import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class MatterQuestionsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      aircraft_model_id: null,
      lista_frotas: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarFrota = this.adicionarFrota.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.frotas) && Array.isArray(newProps.lista_frotas)) {
      this.setState({dados: newProps.frotas, lista_frotas: newProps.lista_frotas});
    }
  }

  adicionarFrota(event) {
    event.preventDefault();
    var datasave = {
      aircraft_model_id: this.state.aircraft_model_id,
      matter_id: this.props.matter_id,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/materia/frota/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var matter_aircraft_model_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa frota?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/frota/' + matter_aircraft_model_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(matter_aircraft_model_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(matter_aircraft_model_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == matter_aircraft_model_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarFrota}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Frotas:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_id"
              value={this.state.aircraft_model_id}
              searchable={true}
              placeholder={'Selecionar Frotas'}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
              options={this.state.lista_frotas}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar frota</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há questões cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="frota" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Frota</TableHeaderColumn>
    
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MatterQuestionsTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MatterAircraftModelsTab.js